import {
    BillType,
    CancellationState,
    FulfillmentPositionDisplayMode,
    FulfillmentProductionState,
    FulfillmentState,
} from "./Enums";
import type { IFulfillmentGroup } from "./FulfillmentGroup";
import type { IOrderItem } from "./Order";
import type { IMultiLanguageText } from "./Shared";
import type { ITable } from "./Table";

//until now, this is only used for location corona client
export interface ITableCovidUserCount extends ITable {
    allocations: number;
}

export interface IRoomPlanTable extends ITable {
    orderBillId?: string;
    allocations: number;
    openBillAmount?: number;
    status: RoomPlanTableStatus;
    timestamp?: Date;
    manualEndUsersCount?: number;
}

export enum RoomPlanTableStatus {
    Default = 0,
    OpenBill = 1,
    UnfulfilledOrder = 2,
    NoOrderMade = 3,
}

export interface IOperatorFulfillment {
    id: string;
    locationId: string;
    fulfillmentGroupId?: string;
    orderId: string;
    orderNumber: string;
    dailyOrderIncrement?: number;
    tableName: string;
    useCaseName?: IMultiLanguageText;
    roomId: string;
    orderDate: Date;
    items: Array<IOrderItem>;
    scheduledFulfillmentDateTime: Date;
    amendedReadyDateTime: Date;
    effectiveReadyDateTime?: Date;
    effectiveFulfillmentDateTime?: Date;
    isFulfilled: boolean;
    isPaid: boolean;
    cancellationState?: CancellationState;
    fulfillmentPositionDisplayMode: FulfillmentPositionDisplayMode;
    state: FulfillmentState;
    currentQueuePosition?: number;
    orderedByWaiterName?: string;
    orderHasOtherFulfillments: boolean;
    isLinked: boolean;
    customTableName?: string;
}

export interface IExtendedOperatorFulfillment extends IOperatorFulfillment {
    fulfillmentGroup?: IFulfillmentGroup;
    productionState: FulfillmentProductionState;
}

export interface IOpenBill {
    billId: string;
    name: string;
    billCustomName?: string;
    billType: BillType;
    openSince: Date;
    openBillAmount: number;
    operatorName: string;
    allocatedGuests: number;
    hasPreorder: boolean;
    latestPreorderDateTime?: Date;
    table: IBillTable;
}

export interface IBillTable {
    locationId: string;
    roomId: string;
    roomName: string;
    tableId: string;
    tableName: string;
    tableNumber: number;
    seats: number;
}

export interface IBaseOpenBill {
    // customName?: string;
    id: string;
    type: BillType;
}
